import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as pullRequest from '../pull-request'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: pullRequest.RESOURCE.payload.dimension.partialId,
      partialId: pullRequest.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Who opened the pull request.',
    isOptional: false,
    name: 'Author',
    partialId: PartialId.Standard.create('author'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
